import React from "react";
import { BusinessStreamPageType } from "../../types/optimizely/businessStreamPage";
import { ContentArea } from "../../components/ContentArea/ContentArea";
import { useHeaderModel } from "../../components/Header/useHeaderModel";
import { MegaMenuPreviewBlock } from "../../components/MegaMenuPreviewBlock/MegaMenuPreviewBlock";
import { SearchBlock } from "../../components/SearchBlock/SearchBlock";
import { ProductCatalogueIntro } from "../../components/ProductCatalogueIntro/ProductCatalogueIntro";
import { getButtonVariant } from "../../utils/getButtonVariant";
import TextAndImageBlock from "../../components/TextAndImageBlock/TextAndImageBlock";
import { OptimizelyCallToActionButtonBlock } from "../../types/optimizely/blocks";
import Button from "../../components/Button/Button";

interface BusinessStreamPageProps {
  content?: BusinessStreamPageType;
}

export const BusinessStreamPage: React.FC<BusinessStreamPageProps> = ({
  content,
}) => {
  if (!content) {
    return <></>;
  }

  const { isLoading, error, data } = useHeaderModel(
    content.contentLink.id.toString()
  );

  if (isLoading) {
    return null;
  }

  const megaMenuSection = data.megaMenuModel.items.find(
    (item) => item.id == content.contentLink.id
  );
  return (
    <>
      <TextAndImageBlock
        image={content.mainImage?.expandedValue ? {
          expandedValue: content.mainImage.expandedValue
        } : undefined}
        title={{
          propertyDataType: "PropertyLongString",
          value: content.name,
          contentLink: null,
        }}
        backgroundColor={{
          propertyDataType: "PropertyLongString",
          value: content.heroBackgroundColor?.value || "primaryTurquoise",
        }}
        description={{
          propertyDataType: "PropertyXhtmlString",
          value: content.additionalIntro?.value,
          contentLink: null,
        }}
        name=""
        justifyNormal
        rightClasses="justify-center md:p-10 p-2"
        rightActions={content.callToActionButtons?.expandedValue?.map?.(
          (button) => {
            const optiButton = button as OptimizelyCallToActionButtonBlock;
            return (
              <Button
                onClick={() =>
                  window.open(optiButton.buttonLink.value, "_self")
                }
                text={optiButton.linkText.value}
                key={optiButton.name}
                variant={getButtonVariant(optiButton.buttonType.value)}
              />
            );
          }
        )}
      />
      {content.showSearchBlock?.value && (
        <SearchBlock
          blockTitle="What are you looking for?"
          searchPlaceholder="Products, services, people..."
        />
      )}
      {(content.productCatalogueIntro?.value ||
        content.productCatalogueCtaButton?.linkText?.value) && (
        <ProductCatalogueIntro
          introduction={content.productCatalogueIntro?.value}
          buttonLink={content.productCatalogueCtaButton?.buttonLink?.value}
          buttonText={content.productCatalogueCtaButton?.linkText?.value}
          buttonVariant={getButtonVariant(
            content.productCatalogueCtaButton?.buttonType?.value
          )}
        />
      )}
      {megaMenuSection && (
        <MegaMenuPreviewBlock
          items={megaMenuSection.editorialBlocks.map((eb) => ({
            id: eb.id,
            imageUrl: eb.image?.url,
            introductionText: eb.introduction,
            text: eb.text,
            title: eb.title,
          }))}
        />
      )}
      <ContentArea contentArea={content.mainContentArea} />
    </>
  );
};
